import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const runSpinHandler: ActionHandler = {
  type: 'run_spin',
  execute(ctx) {
    const config = ctx.config;
    const port = ctx.semanticPorts?.runSpin;
    return invokeSemanticPort(
      ctx,
      'run_spin',
      port
        ? (context) =>
            port(
              {
                wheelId: readString(config, 'wheelId', 'wheel_id'),
                targetBlockId:
                  readString(config, 'targetBlockId', 'target_block_id') ??
                  ctx.intentEnvelope?.payload.context.blockId,
              },
              context
            )
        : undefined
    );
  },
};
